"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PathConfig = void 0;
const path = __importStar(require("path"));
const fs = __importStar(require("fs"));
/**
 * Configuration utility for resolving directory paths across the engine.
 * Supports both absolute and relative paths with sensible defaults.
 */
class PathConfig {
    /**
     * Get the adventures directory path
     * Priority: ADVENTURES_DIRECTORY env var > default relative path
     */
    static getAdventuresDirectory() {
        const envPath = process.env.ADVENTURES_DIRECTORY;
        if (envPath && envPath.trim() !== '') {
            return path.isAbsolute(envPath) ? envPath : path.resolve(__dirname, envPath);
        }
        return path.join(__dirname, '../../adventures');
    }
    /**
     * Get the required scenes directory path
     * Priority: REQUIRED_SCENES_DIRECTORY env var > default relative path
     *
     * Migration note: Previously supported DEFAULT_REQUIRED_SCENES_PATH and REQUIRED_SCENES_PATH
     */
    static getRequiredScenesDirectory() {
        const envPath = process.env.REQUIRED_SCENES_DIRECTORY;
        if (envPath && envPath.trim() !== '') {
            return path.isAbsolute(envPath) ? envPath : path.resolve(__dirname, envPath);
        }
        return path.join(__dirname, '../../required_scenes');
    }
    /**
     * Get the global snippets directory path (repository root / snippets).
     * Priority: SNIPPETS_DIRECTORY env var > default relative path
     */
    static getSnippetsDirectory() {
        const envPath = process.env.SNIPPETS_DIRECTORY;
        if (envPath && envPath.trim() !== '') {
            return path.isAbsolute(envPath) ? envPath : path.resolve(__dirname, envPath);
        }
        return path.join(__dirname, '../../snippets');
    }
    /**
     * Get the variables config file path
     * Priority: VARIABLES_CONFIG_PATH env var > default relative path
     */
    static getVariablesConfigPath() {
        const envPath = process.env.VARIABLES_CONFIG_PATH;
        if (envPath && envPath.trim() !== '') {
            return path.isAbsolute(envPath) ? envPath : path.resolve(__dirname, envPath);
        }
        // Resolve relative to engine package root (where VariablesConfig.md is located)
        // __dirname in compiled code will be engine/dist/utils, so go up to engine root
        return path.resolve(__dirname, '../../VariablesConfig.md');
    }
    /**
     * Verify that a path exists
     * @param fileOrDirPath Path to check
     * @param isDirectory If true, verify it's a directory; if false, verify it's a file
     * @returns true if path exists and matches type, false otherwise
     */
    static verifyPathExists(fileOrDirPath, isDirectory = true) {
        try {
            if (!fs.existsSync(fileOrDirPath)) {
                return false;
            }
            const stats = fs.statSync(fileOrDirPath);
            return isDirectory ? stats.isDirectory() : stats.isFile();
        }
        catch {
            return false;
        }
    }
    /**
     * Resolve a path, supporting both absolute and relative paths
     * @param inputPath Path to resolve
     * @param basePath Base path for relative resolution (defaults to __dirname)
     * @returns Resolved absolute path
     */
    static resolvePath(inputPath, basePath = __dirname) {
        if (path.isAbsolute(inputPath)) {
            return inputPath;
        }
        return path.resolve(basePath, inputPath);
    }
}
exports.PathConfig = PathConfig;
//# sourceMappingURL=pathConfig.js.map